import { DESC, type OrderDirection } from './order-direction.tsx';
import { NAME, DESCRIPTION, LEAD, ISSUES, type OrderField } from './order-field.tsx';

export const ORDER_FIELD_MAP = {
	[NAME]: 'name',
	[DESCRIPTION]: 'description',
	[LEAD]: 'lead',
	[ISSUES]: 'issueCount',
} as const;

export const mapToOrderFetch = (orderField: OrderField, orderDirection: OrderDirection) =>
	(orderDirection === DESC ? '-' : '+') + ORDER_FIELD_MAP[orderField];
